<nav class="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
    <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
        <div class="me-3">
            <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-bs-toggle="minimize">
                <span class="icon-menu"></span>
            </button>
        </div>
        <div>
            <a class="navbar-brand brand-logo" href="index.html">
                Logo
            </a>
            <a class="navbar-brand brand-logo-mini" href="index.html">

            </a>
        </div>
    </div>
    <div class="navbar-menu-wrapper d-flex align-items-top">
        <ul class="navbar-nav ms-auto">

            <li class="nav-item dropdown d-block user-dropdown">
                <a class="nav-link" id="UserDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa-solid fa-circle-user img-xs rounded-circle"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="UserDropdown">
                    <div class="dropdown-header text-center user-box">
                        <i class="fa-solid fa-circle-user img-xs rounded-circle"></i>
                        <p *ngIf="user" class="mb-1 mt-3 fw-semibold uppercase username-wrap">{{user.name}}</p>
                        <p class="fw-light text-muted mb-0">{{role}}</p>
                    </div>
                    <a (click)="logout()" class="cursor-pointer border-0 dropdown-item">
                        <i class="dropdown-item-icon mdi mdi-power color-danger me-2 "></i>
                        Sign Out</a>
                </div>
            </li>
        </ul>
        <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button"
            data-bs-toggle="offcanvas">
            <span class="mdi mdi-menu"></span>
        </button>
    </div>
</nav>